

























































































import {IResource} from 'simpli-web-sdk'
import {Component, Prop, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import AuditByDeliveryRequest from '@/model/request/AuditByDeliveryRequest'
import ItDateInput from '@/components/itrack/ItDateInput.vue'

@Component({components: {ItDateInput}})
export default class FilterAuditByDelivery extends Mixins(MixinMember) {
  @Prop({required: true}) value!: AuditByDeliveryRequest

  async mounted() {
    await this.value.allAuditoriaMotivoFiltro.query()
    await this.value.allStatusNotificacaoAuditoria.query()
  }

  allDocsEvent(item: IResource, cache: IResource[]) {
    this.value.populateAllDocs(cache)
  }

  searchByCTEEvent(item: IResource, cache: IResource[]) {
    this.value.populateSearchByCTE(cache)
  }

}
